import { useCallback, useEffect, useRef, useState } from "react";
import { useGetService } from "./useGetService";
import {
  API,
  DashboardTabs,
} from "../constants";

// Third party
import _ from "lodash";
import { getUserData } from "../shared/utils";
import {
  EServiceRequestCategory,
  IManualRequest,
  IServiceRequest,
  ITmResponse,
} from "../types/global.types";
import { useArrivalDepartureData } from "./useArrivalDepartureData";
import moment from "moment";

export const useTransportManualRequest = (
  startDate: Date,
  endDate: Date,
  selectedTab: string,
  subSelectedTab: string
) => {
  const [rows, setRows] = useState([]);
  const [isRowsLoading, setRowsLoading] = useState(false);
  const vendorId = getUserData()["cognito:username"];

  const assignmentStartDate = moment(startDate);
  const assignmentEndDate = moment(endDate);

  const { response, isLoading, handleSearchApply, refreshingText } =
    useArrivalDepartureData({
      startDate,
      endDate,
      selectedTab,
    });

  // FETCH CREATED MANUAL REQUEST DETAILS
  const {
    response: manualRequestDetails,
    isLoading: ismanualRequestDetailsLoading,
    refetch: refetchManualRequest,
  } = useGetService(
    `${API.VENDOR_SERVICE_REQUEST.CREATE_MANUAL_REQUEST}s?vendorId=${vendorId}`
  );

  const serviceRequestUrl = `${API.CARNIVAL_ADMIN.GET_SERVICE_REQUEST_BY_VENDOR_ID
    }?vendorId=${vendorId}&startDate=${assignmentStartDate.format(
      "DD/MM/YYYY"
    )}&endDate=${assignmentEndDate.format("DD/MM/YYYY")}`


  const {
    response: serviceRequests,
    isLoading: isAssignedDataLoading,
    refetch: refetchAssinged,
  } = useGetService(
    serviceRequestUrl
  );

  // Refetch arrival data when applied dates change (skip initial mount)
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    handleSearchApply();
  }, [startDate, endDate]);

  const dataHandling = useCallback(
    (
      resData: ITmResponse[],
      manualRequestDetails?: IManualRequest[],
      assignedData?: IServiceRequest[]
    ) => {
      if (!manualRequestDetails?.length) return [];

      const manualTmIds = manualRequestDetails.map((x) => x.tmId);

      return resData
        .filter((item) => manualTmIds.includes(item.EmpId))
        .map((x) => ({
          ...x,
          id: x.EmpId,
          assignedInfo:
            !isAssignedDataLoading &&
            assignedData?.find(
              (v: any) => v.tmId === x.EmpId && subSelectedTab === v.requestType
            ),
          isManualRequestCreated:
            (!ismanualRequestDetailsLoading &&
              manualRequestDetails?.some((v) => v.tmId === x.EmpId)) ||
            false,
        }));
    },
    []
  );

  useEffect(() => {
    setRowsLoading(
      isLoading || ismanualRequestDetailsLoading || isAssignedDataLoading
    );

    if (
      !isLoading &&
      Array.isArray(response?.data) &&
      !ismanualRequestDetailsLoading &&
      Array.isArray(manualRequestDetails?.data) &&
      Array.isArray(serviceRequests?.data)
    ) {
      const processedData = dataHandling(
        response.data,
        manualRequestDetails.data,
        serviceRequests.data
      );
      setRows(processedData as any);
    }

    if (!isLoading && response?.data?.length === 0) {
      setRows([]);
    }
  }, [
    response,
    isLoading,
    isAssignedDataLoading,
    serviceRequests,
    ismanualRequestDetailsLoading,
    manualRequestDetails,
    subSelectedTab,
  ]);

  const refetchData = (seltab: string) => {
    refetchAssinged(
      serviceRequestUrl
    );
  };

  return {
    rows,
    isRowsLoading,
    refetchData,
    handleSearchApply,
    refreshingText,
  };
};
